import type { ComboboxOption } from './combobox.types'

export function getComboboxOptionKeywords(option: ComboboxOption): string[] {
  return [option.label]
}
